// This is a client-side-only component

let initialized = false;

export const resetAndTestOIL = () => {
  initialized = false;
};

const initializeOIL = () => {
  if (initialized) return null;

  if (typeof window === "undefined") return;
  if (typeof window.oilConfig === "undefined") return;
  if (window.logger) return;
  const intuitLoggingBundle = require("@appfabric/intuit-logging/build/intuit-logging-bundle");
  window.logger = new intuitLoggingBundle.LoggingUtility();
  window.logger.setConfiguration(window.oilConfig);
  window.onLoggerLoaded && window.onLoggerLoaded();
  initialized = true;

  // Note: This component doesn't show anything. It simply initializes the logger.
  return null;
};

export default initializeOIL;
